import { useRecoilState } from 'recoil'
import { productVariationFavouritesQuery } from '/src/components/commerce/product/productState'

export const useProductFavourite = () => {
  return useRecoilState(productVariationFavouritesQuery)
}